<template>
    <div class="to-progress" @click="toProgress">
        <div class="progress-text">
            <div>查看</div>
            <div>学习进度</div>
        </div>
    </div>
</template>
<script>
import utils from "../../config/utils"
export default {
    data() {
        return {
            school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
        }
    },
    methods: {
        toProgress() {
            this.$router.push(`/${this.$route.params.school}/user/myClass?categoryLevel=1&type=0&oneCateId=469`)
        }
    }
}
</script>
<style scoped lang="less">
.to-progress {
    width: 4.1vw;
    height: 4.2vw;
    border-radius: .52vw 0px 0px .52vw;
    background: linear-gradient(90deg, #C57E3F 0%, #E09E63 100%, );
    // background: linear-gradient(90deg, red, blue);
    box-shadow: 0px 0 12px 0px rgba(129, 129, 129, 0.16);
    position: fixed;
    right: 0;
    top: 72%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;

    &:hover {
        background: #BC6D29;
        box-shadow: 0px 0px 12px 0px rgba(129, 129, 129, 0.16);
    }

    &::before {
        content: "";
        display: block;
        width: 2.5vw;
        height: 0.468vw;
        background-image: url("../../assets/hzvtc/common/progress.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center;
    }

    .progress-text {
        font-weight: bold;
        margin-top: .4vw;
        font-size: .73vw;
        color: #FAF7F1;
        line-height: .938vw;
        text-align: center;
    }
}
</style>